import styled from 'styled-components';
import { LinkButton } from '../button';

export const StyledSummary = styled.div`
  background: #fff;
  border-radius: ${props => props.theme.borderRadius};
  margin: 20px 0 0;
  padding: 30px 20px;
  border: 1px ${props => props.theme.colors.border} solid;

  .title {
    margin: 0 0 30px;
    font-size: ${props => props.theme.fontSizes.large};
    font-weight: 600;
  }
`

export const StyledSummaryItem = styled.div`
  font-size: ${props => props.theme.fontSizes.small};
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;

  .edit-link {
    text-transform: lowercase;
  }

  strong {
    font-weight: 600;
  }

  & + & {
    margin-top: 15px;
    padding-top: 15px;
    border-top: 1px ${props => props.theme.colors.border} dotted;
  }

  .hint {
    font-size: ${props => props.theme.fontSizes.extraSmall};
    margin-top: 3px;
    color: #999;
  }

  &.total {
    background: #eee;
    margin: 15px -20px -30px;
    padding: 20px;
    border-radius: 0 0 ${props => props.theme.borderRadius} ${props => props.theme.borderRadius};
    font-size: ${props => props.theme.fontSizes.normal};
  }
`

export const StyledFreeShipping = styled.span`
  color: #00a107;
  font-weight: bold
`

export const StyledCoffeeSummary = styled.div`
  font-size: ${props => props.theme.fontSizes.extraSmall};
  margin: 10px 0 0;

  .item {
    & + .item {
      margin-top: 7px;
    }
  }
`

export const StyledSummaryItemLink = styled(LinkButton)`
  margin-left: 10px;
  color: ${props => props.theme.colors.primary};
  text-decoration: underline;
  cursor: pointer;
`

export const StyledProductsSummary  = styled.span`
  small {
    margin-left: 10px;
  }
`